import DocumentTab from '@/components/TabSpr.vue'
import InputGroupForm from '@/components/InputGroupForm.vue'
import http from '@/http-common'
import global from '@/utils/global'

export default {
  name: "DocumentList",
  components: {DocumentTab, InputGroupForm},
  props: {
    isCalled: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [
        {key: 'docType', label: 'Тип документа'},
        {key: 'nameDoc', label: 'Наименование'},
        {key: 'dateDoc', label: 'Дата документа'},
        {key: 'commentDoc', label: 'Описание'},
        {key: 'edit_field', label: '', class: 'width10'}
      ],
    }
  },
  watch: {
    file: function(val) {
      this.selectedItem.nameDoc = val.name
    }
  },
  computed: {
    classCol: function () {
      return {
        'col-xs-12 col-sm-12 col-md-12 col-lg-12': this.isCalled,
        'col-xs-12 col-sm-12 col-md-10 col-lg-10 offset-lg-1 offset-md-1': !this.isCalled
      }
    },
  },
  data() {
    return {
      items: [],
      captiontable: 'Документы',
      caption: {
        name: 'Документ',
        nameR: 'Документ'
      },
      urls: {
        save: '/document/save',
        delete: '/document/delete',
      },
      modalEditOpened: false,
      selectedItem: {id: null, docTypeId: null},
      validValue: {
        nameDoc: true,
        docType: true,
        dateDoc: true,
        file: true,
        form: true
      },
      stacked: {
        flg: false,
        size: 'md'
      },
      typeList: [],
      fileType: '.pdf',
      file: null,
      pathStr: 'documents',
      modalLoadOpened: false
    }
  },
  created() {
    this.loadItems()
    this.loadTypesDoc()
  },
  methods: {
    checkForm() {
      for (var key in this.validValue) {
        this.validValue[key] = true;
      }
      if (this.selectedItem.exitsFile || this.file) {
        this.validValue.file = true;
        this.validValue.form = true;
      } else {
        this.validValue.file = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.dateDoc) {
        this.validValue.dateDoc = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.nameDoc || this.selectedItem.nameDoc === '') {
        this.validValue.nameDoc = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.docTypeId || this.selectedItem.docTypeId === 0) {
        this.validValue.docType = false;
        this.validValue.form = false;
      }
    },
    loadItems() {
      var vm = this;
      http.get('/document/list')
      .then((response) => {
        vm.items = response.data;
      })
      .catch((error) => console.log(error.response.data));
    },
    rowSelected(items) {
      this.selected = items;
      for (var key in items[0]) {
        this.selectedItem[key] = items[0][key];
      }
      this.$emit('input', this.selectedItem)
    },
    showEditDialog() {
      for (var key in this.validValue) {
        this.validValue[key] = true;
      }
      if (this.isCalled && this.selectedItem.id > 0) {
        this.rowSelected([this.selectedItem]);
        this.$emit('selectItem')
      } else {
        if (this.selectedItem.exitsFile === true) {
          this.selectedItem.url = global.getFullUrlDocument(
              this.selectedItem.keyFile)
        } else
          this.selectedItem.url = ''
        if (this.selectedItem.id == null)
          this.selectedItem.dateDoc = global.getFormattedDate(new Date())
        this.modalEditOpened = !this.modalEditOpened;
      }
    },
    saveDocument() {
      this.checkForm();
      if (this.validValue.form) {
        this.modalEditOpened = false;
        this.$refs.DocumentTab.save(this.selectedItem);
      }
    },
    loadTypesDoc() {
      var vm = this;
      http.get('/workkind/DOC_TYPE/list')
      .then((response) => {
        vm.typeList = []
        response.data.forEach( function (x) {
          var rec = {}
          rec.value = x.id;
          rec.text = x.name;
          vm.typeList.push(rec);
        })
      })
      .catch((error) => console.log(error.response.data));
    },
    downloadFile() {
      var vm = this;
      this.modalLoadOpened = true;
      var exp = 'pdf';
      if (vm.selectedItem.keyFile && vm.selectedItem.keyFile.lastIndexOf(".") >= 0)
        exp = vm.selectedItem.keyFile.substring(vm.selectedItem.keyFile.lastIndexOf(".") + 1)
      http.get(this.selectedItem.url,
          {
            responseType: 'blob',
          }
      ).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        var str = global.getExt(vm.selectedItem.nameDoc)
        if (str && str !== '')
          link.setAttribute('download', vm.selectedItem.nameDoc);
        else
          link.setAttribute('download', vm.selectedItem.nameDoc + '.' + exp);
        document.body.appendChild(link);
        link.click();
      }).finally(() => vm.modalLoadOpened = false);
    },
    submitFile() {
      let formData = new FormData();
      if (!this.selectedItem.keyFile)
        this.selectedItem.keyFile = 'doc_0';
      var fileName = this.selectedItem.keyFile;
      var vm = this;
      if (this.file) {
        formData.append('file', vm.file);
        http.post('/report/' + vm.pathStr + '?name=' + fileName,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        ).then(function (response) {
          vm.selectedItem.keyFile = response.data.name;
          if (response.data.ok || response.data.name !== '') {
            // var link = '/report/download/doc/' + vm.pathStr + '?name=' + encodeURIComponent(file_name);
            // vm.downloadDocument = link;
            // vm.dfileDocument = response.data.name.replace(file_name, "Документ_" + vm.selectedItem.nameDoc);
            vm.saveDocument()
          }
        }).catch(error => {
          alert(error.message);
        });
      } else {
        vm.saveDocument()
      }
    },
  }
}
